import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
  newPasTipMessage: string = '';
  newPasTipView: boolean = false;
  passConfig: any;
  passConfigArr: {}[];
  passConcigArrView: boolean = false;
  confirmDirty: boolean = false;
  // 修改手机号
  changePhoneNum: any = undefined;
  credential: any = undefined;
  validateCodeKey: string = undefined;
  visibleChangePhoneM: boolean = false;
  stepChangePhone: number = 1;
  verificationCounter: number = 0;
  validateSending: boolean = false;
  // 用户登录信息
  accountInfo: AccountInfo = {
    email: undefined,
    nickName: undefined,
    phone: undefined,
  };

  // 直接改变联系方式
  changContactVisibleM: boolean = false;
  // 手机或者邮箱
  changContactType: string;
  changContactValue: string;

}

interface AccountInfo{
  email: string;
  nickName: string;
  phone: string;
}


// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/Modules.State.ts